export default {
  SPECIAL_CONTRIBUTION_REPOSITORY: Symbol.for('SPECIAL_CONTRIBUTION_REPOSITORY'),
  GET_NOTIFY_SPECIAL_CONTRIBUTION_QUERY: Symbol.for('GET_NOTIFY_SPECIAL_CONTRIBUTION_QUERY'),
  UPLOAD_VOUCHER_SPECIAL_CONTRIBUTION_COMMAND: Symbol.for('UPLOAD_VOUCHER_SPECIAL_CONTRIBUTION_COMMAND'),
};
